import script from "./ReportFeedback.vue?vue&type=script&lang=ts&setup=true"
export * from "./ReportFeedback.vue?vue&type=script&lang=ts&setup=true"

import "./ReportFeedback.vue?vue&type=style&index=0&id=d6547d3a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d6547d3a"]])

export default __exports__